import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { Meta, Title } from '@angular/platform-browser';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class CountrydetailpageService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService,
    private upmeta: Meta,
    private title: Title
  ) {}

  countryDetailData: any;

  private heroSubject$ = new BehaviorSubject<any>(null);
  public hero$ = this.heroSubject$.asObservable();
  private featuresSubject$ = new BehaviorSubject<any>(null);
  public features$ = this.featuresSubject$.asObservable();
  private faqSubject$ = new BehaviorSubject<any>(null);
  public faq$ = this.faqSubject$.asObservable();
  private testimonialsSubject$ = new BehaviorSubject<any>(null);
  public testimonials$ = this.testimonialsSubject$.asObservable();
  private coverageSubject$ = new BehaviorSubject<any>(null);
  public coverage$ = this.coverageSubject$.asObservable();
  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();

  getCountryDetailPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.coveragePage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.countryDetailData = mod.filter(
          x => x?.fields['id'] == PageId.coverageCountryNigeriaAlt
        );
        const heroData =
          this.countryDetailData[0]?.fields?.heroContentPanel?.fields;
        if (heroData) {
          this.heroSubject$.next(heroData);
        }
        const featuresData = this.countryDetailData[0]?.fields;
        if (featuresData) {
          this.featuresSubject$.next(featuresData);
        }
        const testimonialsData =
          this.countryDetailData[0]?.fields?.customerTestimonialsContentPanel
            ?.fields;
        if (testimonialsData) {
          this.testimonialsSubject$.next(testimonialsData);
        }
        const faqData = this.countryDetailData[0]?.fields?.faq?.fields;
        if (faqData) {
          this.faqSubject$.next(faqData);
        }
        const coverageData =
          this.countryDetailData[0]?.fields?.coverage?.fields;
        if (coverageData) {
          this.coverageSubject$.next(coverageData);
        }
        const getStarted =
          this.countryDetailData[0]?.fields?.getStartedContentPanel?.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
      });
  }
  getCountryDetailByID(id: string): Promise<Entry<any>[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          access_token: PageId.accessToken,
          include: 10,
          content_type: PageId.coveragePage,
          'fields.id': id,
        })
      )
      .then(res => res.items);
  }
  getAllCountryDetail(): Promise<any[]> {
    return this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.coveragePage,
          include: 10,
          limit: 300
        })
      )
      .then(res => {
        const mod = res.items as any[];
        return mod;
      });
  }
  getCountryDetailByIDData(id: string) {
    this.getCountryDetailByID(id).then(data => {
      if (data.length > 0) {
        this.countryDetailData = data;
        const heroData = this.countryDetailData[0]?.fields;
        if (heroData) {
          this.heroSubject$.next(heroData);
        }
        const featuresData = this.countryDetailData[0]?.fields;
        if (featuresData) {
          this.featuresSubject$.next(featuresData);
        }
        const testimonialsData =
          this.countryDetailData[0]?.fields?.customerTestimonialsContentPanel
            ?.fields;
        if (testimonialsData) {
          this.testimonialsSubject$.next(testimonialsData);
        }
        const faqData = this.countryDetailData[0]?.fields?.faq?.fields;
        if (faqData) {
          this.faqSubject$.next(faqData);
        }
        const coverageData =
          this.countryDetailData[0]?.fields?.coverage?.fields;
        if (coverageData) {
          this.coverageSubject$.next(coverageData);
        }
        const getStarted =
          this.countryDetailData[0]?.fields?.getStartedContentPanel?.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }

        const seoData =
          this.countryDetailData[0]?.fields?.seoMetadataReference?.fields;
        if (seoData) {
          this.meta.updateMeta(seoData);
        }
      }
    });
  }
}
